import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-2" }

import { useI18n } from "vue-i18n";
import { ref } from "vue";
import VideoIcon from "@/components/icons/VideoIcon.vue";
import ModalComponent from "@/components/ModalComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoInstructionButton',
  setup(__props) {

const { t } = useI18n();
const showInstructionModal = ref(false);
const videoUrl =
  process.env.VUE_APP_URL + "/storage/instruction/planning-instruction.mp4";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "shrink-0 h-9 w-full rounded-[100px] border border-brown text-sm text-brown",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showInstructionModal.value = true))
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.video-instruction")), 1),
        _createVNode(VideoIcon, { class: "size-5" })
      ])
    ]),
    _createVNode(ModalComponent, {
      maxModalSizeClass: "max-w-5xl",
      show: showInstructionModal.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (showInstructionModal.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", { class: "w-full" }, [
          _createElementVNode("video", {
            controls: "",
            playsinline: "",
            preload: "metadata",
            width: "100%"
          }, [
            _createElementVNode("source", {
              src: videoUrl,
              type: "video/mp4"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})